const defaultTextValues = {
  sectionTitle: {
    en: 'Testimonials',
  },
  testimonialMark: {
    en: '“',
  },
  testimonialOne: {
    en: 'Vivamus pulvinar semper diam, et sagittis augue dapibus vel. Integer eget nulla nec sem iaculis tempus. Mauris auctor et eros et luctus. Mauris purus sem, efficitur eu dignissim in, tristique a risus.'
  },
  testimonialOneAuthor: {
    en: 'Author Name'
  },
  testimonialOneCompany: {
    en: 'Author company'
  },
  testimonialTwo: {
    en: 'Vivamus pulvinar semper diam, et sagittis augue dapibus vel. Integer eget nulla nec sem iaculis tempus. Mauris auctor et eros et luctus. Mauris purus sem, efficitur eu dignissim in, tristique a risus.'
  },
  testimonialTwoAuthor: {
    en: 'Author Name'
  },
  testimonialTwoCompany: {
    en: 'Author company'
  },
  testimonialThree: {
    en: 'Vivamus pulvinar semper diam, et sagittis augue dapibus vel. Integer eget nulla nec sem iaculis tempus. Mauris auctor et eros et luctus. Mauris purus sem, efficitur eu dignissim in, tristique a risus.'
  },
  testimonialThreeAuthor: {
    en: 'Author Name'
  },
  testimonialThreeCompany: {
    en: 'Author company'
  }
};

export default defaultTextValues;
